import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

/**
 * Back to the top on a new page. A URL that carries a fragment («#sales-stat-clienti.persi») names
 * a place to land, and the page scrolls there itself once it has rendered: resetting to the top
 * here would run after it and undo it, so a fragment is left alone.
 */
export function useScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
    // The fragment is read when the path changes, never as a trigger of its own.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
